import * as React from 'react';
import { BaseComponent } from './BaseComponent';
import { ViewSettingsStore, LockState } from '../stores/ViewSettingsStore';
import { UIHelper } from '../utils/UIHelper';
import { LoadingAnimation } from './LoadingAnimation';

interface CompleteLockState {
    locked: LockState;
    component: JSX.Element | null;
    transparent: boolean;
}

export class CompleteLock extends BaseComponent<{}, CompleteLockState> {
    public componentWillMount(): void {
        this.addStoreListener(ViewSettingsStore, this.onChange);
        this.onChange();
    }

    public render(): JSX.Element | null {
        if (this.state.locked !== LockState.UNLOCKED) {
            let content: JSX.Element | null = null;
            switch (this.state.locked) {
                case LockState.ANIMATION:
                    content = <LoadingAnimation key="animation"/>;
                    break;
                case LockState.COMPONENT:
                    content = this.state.component;
                    break;
                default:
                    break;
            }

            return (
                <div
                    className={'main-lock' + (this.state.transparent ? ' main-lock-transparent' : '')}
                    onClick={UIHelper.stopEvent}
                    onTouchMove={UIHelper.stopEvent}
                >
                    {content}
                </div>
            );
        }
        return null;
    }

    protected onChange = (): void => {
        this.setState({
            locked: ViewSettingsStore.getState().alllocked,
            component: ViewSettingsStore.getState().alllockedComponent,
            transparent: ViewSettingsStore.getState().alllockedTransparency,
        });
    };
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/CompleteLock.tsx